import { useEffect } from "react";

export const useZoom = (setZoom: (zoom: (prev: number) => number) => void) => {
  const zooms = [0.5, 1, 2, 4, 6];
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "+" || e.key === "=") {
        setZoom((prev) => zooms[Math.min(zooms.indexOf(prev) + 1, zooms.length - 1)]);
      } else if (e.key === "-" || e.key === "_") {
        setZoom((prev) => zooms[Math.max(zooms.indexOf(prev) - 1, 0)]);
      } else if (e.key === "0") {
        setZoom((prev) => 1);
      }
    };

    window.addEventListener("keypress", handleKeyPress);
    return () => window.removeEventListener("keypress", handleKeyPress);
  }, []);
};

export const getSelectedItemsUuids = (selectionBox: Element) =>
  Array.from(document.querySelectorAll("[data-uuid]"))
    .filter((box) => elementContainsElement(selectionBox, box))
    .map((el: HTMLElement) => el.dataset.uuid);

export const elementContainsElement = (container: Element, element: Element) => {
  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  return (
    elementRect.left >= containerRect.left &&
    elementRect.right <= containerRect.right &&
    elementRect.top >= containerRect.top &&
    elementRect.bottom <= containerRect.bottom
  );
};

export const selectionBoxPositionStyle = (
  drag: {
    action: string;
    startPoint: { x: number; y: number };
    delta: { x: number; y: number };
  },
  selectionBoxElement: Element
) => {
  if (drag.action !== "selection") return { display: "none" };

  const parentBox = selectionBoxElement.parentElement?.getBoundingClientRect();
  const startX = drag.startPoint.x - parentBox.left;
  const startY = drag.startPoint.y - parentBox.top;
  const endX = startX + drag.delta.x;
  const endY = startY + drag.delta.y;

  return {
    display: "block",
    left: Math.min(startX, endX),
    top: Math.min(startY, endY),
    width: Math.abs(drag.delta.x),
    height: Math.abs(drag.delta.y),
  };
};

export const arrayMode = (arr: number[]) => {
  const counts = arr.reduce(
    (count, num) => ({ ...count, [num]: (count[num] || 0) + 1 }),
    {}
  );
  return Object.entries(counts).reduce((a, [k, v]) => (v > counts[a] ? k : a), arr[0]);
};
